// src/components/GroupList.js

import React, { useState, useEffect } from 'react';
import { GroupListhooks } from '../../Helper/GroupHelper';
import { Link } from 'react-router-dom';
import { hasCreatePermission, hasEditPermission, hasdeletePermission, hasSharePermission } from '../../Utils/PermissionUtils';
import ShareModal from '../../Utils/ShareModal';
import AddScreenModal from '../../Utils/AddScreenModal';
import AddLayoutModal from '../../Utils/AddLayoutModal';
import AddUserModal from '../../Utils/AddUserModal';
import { toast } from 'react-toastify';
import service from '../../Services/service';
import DeleteModal from '../../Utils/DeleteModal';

const GroupListComponent = (props) => {
    const [Groups, setGroups] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('Name');
    const [sortDescending, setSortDescending] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalitems, setTotalitems] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [showScreenModal, setShowScreenModal] = useState(false);
    const [showLayoutModal, setShowLayoutModal] = useState(false);
    const [selectedScreenName, setSelectedScreenName] = useState('');
    const [selectedrowId, setSelectedRowId] = useState(0);

    const canEditGroup = hasEditPermission('Group');
    const canDeleteGroup = hasdeletePermission('Group');
    const canShareGroup = hasSharePermission('Group');
    const [deleteId, setDeleteId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showUserModal, setshowUserModal] = useState(false);

    useEffect(() => {
        getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
    }, [searchTerm, sortBy, sortDescending, pageNumber, pageSize, props.id]);

    async function getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {
        const data = await GroupListhooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize, props.id);
        if (data) {
            setGroups(data.items);
            setTotalPages(data.totalPages);
            setTotalitems(data.totalItems);
        }
    }

    const handleSortChange = (event) => {
        const [field, order] = event.target.value.split('_');
        setSortBy(field);
        setSortDescending(order === 'desc');
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPageNumber(newPage);
        }
    };

    const handleDeleteClick = (id, name) => {
        setSelectedScreenName(name);
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await service.getdata("Group/DeleteById?id=" + deleteId);
            if (response !== undefined) {
                toast.success('Group Deleted successfully!');
                // Replace below with your actual refresh logic
                getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
            }
        } catch (error) {
            toast.error('Error deleting Content. Please try again.');
        } finally {
            setShowDeleteModal(false);
        }
    };

    return (
        <div className="container-fluid content-top-gap">
            <nav aria-label="breadcrumb" className="mb-4">
                <ol className="breadcrumb my-breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Group List</li>
                </ol>
            </nav>

            <div className="card card_border mb-4">
                <div className="card-header chart-grid__header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">
                        {{
                            1: 'Layout Group List',
                            2: 'Screen Group List',
                            3: 'User Group List',
                            6: 'Content Group List',
                            8: 'Permission Group List'
                        }[props.id] || ''}

                    </h5>
                    {hasCreatePermission('Group') && (
                        <Link to="/CreateGroup" className="btn btn-primary btn-sm">
                            Add Group
                        </Link>
                    )}
                </div>

                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by name..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4 mt-2 mt-md-0">
                            <select
                                className="custom-select"
                                onChange={handleSortChange}
                                value={`${sortBy}_${sortDescending ? 'desc' : 'asc'}`}
                            >
                                <option value="Name_asc">Name (A-Z)</option>
                                <option value="Name_desc">Name (Z-A)</option>
                                <option value="CreatedAt_asc">Created At (Oldest)</option>
                                <option value="CreatedAt_desc">Created At (Newest)</option>
                                <option value="UpdatedAt_asc">Updated At (Oldest)</option>
                                <option value="UpdatedAt_desc">Updated At (Newest)</option>
                                <option value="CreatedBy_asc">Created By (A-Z)</option>
                                <option value="CreatedBy_desc">Created By (Z-A)</option>
                            </select>
                        </div>
                        <div className="col-md-4 mt-2 mt-md-0">
                            <select
                                className="custom-select"
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setPageNumber(1); // reset to page 1
                                }}
                            >
                                <option value={10}>Show 10</option>
                                <option value={20}>Show 20</option>
                                <option value={50}>Show 50</option>
                                <option value={100}>Show 100</option>
                            </select>
                        </div>
                    </div>

                    <table className="table table-striped table-bordered table-hover" style={{ fontSize: '14px' }}>
                        <thead className="thead-dark">
                            <tr>
                                <th>S No</th>
                                <th>Name</th>
                                <th>Description</th>
                                <th style={{ width: '220px' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Groups.map((Group, index) => (
                                <tr key={Group.groupId}>
                                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                                    <td>{Group.groupName}</td>
                                    <td>{Group.description}</td>
                                    <td>
                                        <div className="btn-group " role="group">
                                            {canEditGroup && (
                                                <>
                                                    <Link to={`/EditGroup/${Group.groupId}`} className="btn btn-outline-info btn-sm" title="Edit Group">
                                                        Edit
                                                    </Link>
                                                    {props.id === "1" && (
                                                        <Link
                                                            className="btn btn-outline-primary btn-sm"
                                                            title="Add Layout"
                                                            onClick={() => {
                                                                setSelectedScreenName(Group.groupName);
                                                                setShowLayoutModal(true); // You must define this modal logic
                                                                setSelectedRowId(Group.groupId);
                                                            }}
                                                        >
                                                            Add Layout
                                                        </Link>
                                                    )}

                                                    {props.id === "2" && (
                                                        <Link
                                                            className="btn btn-outline-primary btn-sm"
                                                            title="Add Display"
                                                            onClick={() => {
                                                                setSelectedScreenName(Group.groupName);
                                                                setShowScreenModal(true); // Your existing logic
                                                                setSelectedRowId(Group.groupId);
                                                            }}
                                                        >
                                                            Add-Display
                                                        </Link>
                                                    )}
                                                    {props.id === "3" && (
                                                        <Link
                                                            className="btn btn-outline-primary btn-sm"
                                                            title="Add Users"
                                                            onClick={() => {
                                                                setSelectedScreenName(Group.groupName);
                                                                setshowUserModal(true); // Your existing logic
                                                                setSelectedRowId(Group.groupId);
                                                            }}
                                                        >
                                                            Add-Users
                                                        </Link>
                                                    )}


                                                </>
                                            )}

                                            {canDeleteGroup && (
                                                <Link to="#" className="btn btn-outline-danger btn-sm" title="Delete Group" onClick={() => handleDeleteClick(Group.groupId, Group.groupName)}>
                                                    Delete
                                                </Link>
                                            )}
                                            {
                                                canShareGroup && (
                                                    <Link
                                                        className="btn btn-outline-success btn-sm"
                                                        title="Share Group"
                                                        onClick={() => {
                                                            setSelectedScreenName(Group.groupName);
                                                            setShowModal(true);
                                                            setSelectedRowId(Group.groupId);
                                                        }}
                                                    >
                                                        Share
                                                    </Link>
                                                )
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="text-center mt-3">
                        <button
                            className="btn btn-outline-primary btn-sm mx-2"
                            onClick={() => handlePageChange(pageNumber - 1)}
                            disabled={pageNumber === 1}
                        >
                            Previous
                        </button>
                        <small className="mx-2">Page {pageNumber} of {totalPages}</small>
                        <button
                            className="btn btn-outline-primary btn-sm mx-2"
                            onClick={() => handlePageChange(pageNumber + 1)}
                            disabled={pageNumber === totalPages}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
            <ShareModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                screenName={selectedScreenName}
                moduleId={7}
                rowId={selectedrowId}
            />
            <AddScreenModal
                show={showScreenModal}
                handleClose={() => setShowScreenModal(false)}
                groupName={selectedScreenName}
                rowId={selectedrowId}
            />

            <AddScreenModal
                show={showScreenModal}
                handleClose={() => setShowScreenModal(false)}
                groupName={selectedScreenName}
                rowId={selectedrowId}
            />
            <AddLayoutModal
                show={showLayoutModal}
                handleClose={() => setShowLayoutModal(false)}
                groupName={selectedScreenName}
                rowId={selectedrowId}
            />

            <DeleteModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this Group Item?"
                itemName={selectedScreenName}
            />
            <AddUserModal
                show={showUserModal}
                handleClose={() => setshowUserModal(false)}
                groupName={selectedScreenName}
                rowId={selectedrowId}
            />

        </div>
    );
};

export default GroupListComponent;
